import axios from 'axios';

const state= {
    EquipmentModel:{
        items:[],
        total:0
    },
    EquipmentModelLoadings:{
        list:true
    }
};

const getters = {
    EquipmentModel : (state) => state.EquipmentModel,
    EquipmentModelLoadings : (state) => state.EquipmentModelLoadings,
};

const actions = {
    async getItemsWithBrand({commit}, params){
        let brandId = params;
        return new Promise (( resolve, reject ) => {
            commit( 'setEquipmentModelLoadings', {key:"list",val:true});
            global.axios.get(`api/equipment/models`, {params:{
                    type_brand_id:brandId,
                }})
                .then(response => {
                    commit( 'setEquipmentModelLoadings', {key:"list",val:false});
                    commit( 'setItems', response.data.data );
                    resolve( response );
                })
                .catch(error => reject( error ));
        });
    },
};

const mutations = {
    setItems (state,data) {
        state.EquipmentModel.items = data;
        state.EquipmentModel.total = data.length;
    },
    setEquipmentModelLoadings (state,data) {
        if(data.key === "list"){
            state.EquipmentModelLoadings.list = data.val;
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}